let load = file => {
  return () => System.import('../components/Pages/' + file)
}

let routes = [

  { path: '/', component: load('Homepage') },

  { path: '/about/', component: load('About') },
  { path: '/about/print/', component: load('About/Print') },
  { path: '/about/branding/', component: load('About/Branding') },
  { path: '/about/digital/', component: load('About/Digital') },

  { path: '/work/', component: load('Projects/ProjectListing') },
  { path: '/work/:project', component: load('Projects/Project') },
  { path: '/cookie-policy/', component: load('Cookie') },
  { path: '/contact/', component: load('Contact') },

  { path: '/studio', redirect: '/work' },

  { path: '/account-manager', component: load('AccountManager') },

  { path: '*', component: load('404') }

]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js